import { FC, useMemo } from "react";
import { TypographyProps } from "@mui/material";
import { TypographyWithTooltip } from "../../../../../../../../common/TypographyWithTooltip";
import { TooltipText } from "../../../../../../../../common/TooltipText";

interface TargetTypographyProps {
  target: string;
  typographyProps?: Omit<TypographyProps, "title">;
}

export const ElbTargetTypography: FC<TargetTypographyProps> = ({
  typographyProps,
  target,
}) => {
  const formattedTarget = useMemo(() => {
    if (!target.toLowerCase().includes("app")) {
      return target;
    }

    const seperated = target.split("/");
    const index =
      seperated.findIndex((value) => value.toLowerCase().includes("app")) + 1;
    const newValue = seperated.toSpliced(0, index).join("/");

    return `...${newValue}`;
  }, [target]);

  if (formattedTarget === target) {
    return (
      <TypographyWithTooltip
        variant="inherit"
        title={target}
        {...typographyProps}
      />
    );
  }

  return (
    <TooltipText
      variant="inherit"
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
      tooltipTitle={target}
      sx={textStyles}
      {...typographyProps}
    >
      {formattedTarget}
    </TooltipText>
  );
};

const textStyles = {
  textDecoration: "none",
  textUnderlineOffset: 0,
  display: "block",
};
